function extractFaqItems(innerBlocks) {
  if (!innerBlocks || !Array.isArray(innerBlocks)) {
    return [];
  }
  return innerBlocks.map(function extractQuestionAndAnswerFromInnerBlock(item) {
    var _a;
    const question = ((_a = item.attrs) == null ? void 0 : _a.heading) || "";
    const DD_TAG = "<dd>";
    const DD_CLOSE_TAG = "</dd>";
    let answer = "";
    if (item.innerHTML) {
      const indexOfDdTag = item.innerHTML.indexOf(DD_TAG);
      const indexOfDdCloseTag = item.innerHTML.indexOf(DD_CLOSE_TAG, indexOfDdTag);
      if (indexOfDdTag !== -1 && indexOfDdCloseTag !== -1) {
        answer = item.innerHTML.substring(indexOfDdTag + DD_TAG.length, indexOfDdCloseTag).trim();
      }
    }
    return {
      question,
      answer
    };
  });
}
export {
  extractFaqItems
};
